export default class StringHelper {
	static trimUrlOrigin(str) {
		return str.replace(/^http(s?):\/\/[^\/]+(?=\/)/, '');
	}

	static capitalize(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	static decapitalize(str) {
		return str.charAt(0).toLowerCase() + str.slice(1);
	}
}